<div *ngIf="!vm.showOnlyThankYouSection && !vm.showFreeInputSection">
<section *ngIf="!vm.loading">
	<div id="benuLogoContainer" class="o-grid__cell c-text c-text--heading c-text--xl u-osb-lg o-grid__cell--w-100" *ngIf="vm.thirdPartyRenewal === 'benu'">
		<img src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/logo/benu-logo.png" style="max-width: 45%" class="u-hidden@md-and-up">
		<img src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/logo/benu-logo.png" style="max-width: 12%" class="u-hidden@up-to-md">
	</div>
  <h1 class="o-grid__cell c-text c-text--heading c-text--xl u-osb-lg o-grid__cell--w-100">{{'PreVisit.Prescription_List.Title' | translate}}</h1>
  <div *ngIf="vm.prescriptions?.length">
    <div class="o-grid o-grid--wrap u-osb-sm" >
      <div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-70@sm-and-up u-osb-sm@up-to-md">
        <p>{{'PreVisit.Prescription_List.Select_Prescription_To_Renew' | translate}}<br/>
          <span *ngIf="vm.isPreVisit">
            {{'PreVisit.Card.Text_PrescriptionRenewDisclaimer' | translate}}
            <br/>
            <a [routerLink]="['/pre-visit/service/request']" [queryParams]="{ parentCategory: 'NEW_PRESCRIPTION_REQUEST' }">{{'PreVisit.Card.Text_PrescriptionRenewDisclaimerLink' | translate}}</a>
          </span>
        </p>
      </div>
      <div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-30@sm-and-up c-text--right">
        <button id="toggleAllOrActiveButton" class="c-button c-button--s1"
                (click)="vm.showRenewablePrescriptions = !vm.showRenewablePrescriptions">
          <span *ngIf="!vm.showRenewablePrescriptions">{{'PreVisit.Prescription_List.Show_All' | translate}}</span>
          <span *ngIf="vm.showRenewablePrescriptions">{{'PreVisit.Prescription_List.Show_Active' | translate}}</span>
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="!vm.prescriptions?.length">
    <div class="o-grid" >
      <div class="o-grid__cell o-grid__cell--w-100 u-osb-sm">
        <p *ngIf="vm.isPreVisit && !vm.xRoadProblems">{{'PreVisit.Prescription_List.No_Prescriptions_Message_Pre_Visit' | translate}}</p>
        <p *ngIf="!vm.isPreVisit && !vm.xRoadProblems">{{'PreVisit.Prescription_List.No_Prescriptions_Message' | translate}}</p>
        <p class="c-text--bold" *ngIf="vm.xRoadProblems">{{ vm.xRoadErrorMessage }}</p>
      </div>
    </div>
    <div class="o-grid u-osb-sm">
      <div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-50@md-and-up">
        <a *ngIf="vm.isPreVisit" [routerLink]="['/pre-visit/service/request']" [queryParams]="{ parentCategory: 'NEW_PRESCRIPTION_REQUEST' }"
			class="c-button c-button--s1 c-button--narrow c-button--fit@up-to-sm">
			{{'PreVisit.Prescription_List.Talk_To_GP' | translate }}
        </a>
        <a *ngIf="!vm.isPreVisit" 
        	[routerLink]="['/booking/instant']" 
        	[queryParams]="{ category: 'GENERAL_MEDICAL_PRACTICE', origin: 'minudoc.ee' }"
			class="c-button c-button--s1 c-button--narrow c-button--fit@up-to-sm">
			{{'PreVisit.Prescription_List.Talk_To_GP' | translate }}
        </a>
      </div>
    </div>
  </div>
</section>
<section class="c-section u-no-pb">
    <div class="o-grid">
      <div class="o-grid__cell c-cell">
        <div class="c-card">
          <div class="c-content" id="{{vm.uid}}" [ngStyle]="!vm.isInitialized && {'min-height': '200px'}">
            <div *ngIf="!vm.loading">
              <div>
                <div class="c-content c-content--border-bottom u-no-pt u-no-ph@md-and-up u-hidden@up-to-md">
                  <div class="o-grid o-grid--wrap ">
                    <div class="o-grid__cell o-grid__cell--w-15 u-no-p">
                      <p class="c-text c-text--gray">{{'PreVisit.Prescription_List.Prescription_Number' | translate}}</p>
                    </div>
                    <div class="o-grid__cell o-grid__cell--w-10 u-no-p">
                      <p class="c-text c-text--gray">{{'PreVisit.Prescription_List.Date_Issued' | translate}}</p>
                    </div>
                    <div class="o-grid__cell o-grid__cell--w-15 u-no-p">
                      <p class="c-text c-text--gray">{{'PreVisit.Prescription_List.Status' | translate}}</p>
                    </div>
                    <div class="o-grid__cell o-grid__cell--w-20 u-no-p">
                      <p class="c-text c-text--gray">{{'PreVisit.Prescription_List.Substance' | translate}}</p>
                    </div>
                    <div class="o-grid__cell o-grid__cell--w-15 u-no-p">
                      <p class="c-text c-text--gray">{{'PreVisit.Prescription_List.Valid_Until' | translate}}</p>
                    </div>
                    <div class="o-grid__cell o-grid__cell--w-15 u-no-p">
                      <p class="c-text c-text--gray">{{'PreVisit.Prescription_List.Sold_Preparation_Name' | translate}}</p>
                    </div>
                    <div class="o-grid__cell o-grid__cell--w-20 c-text--right u-no-p"></div>
                  </div>
                </div>
                <ul class="c-list" *ngIf="vm.prescriptions?.length">
                  <li *ngFor="let prescription of vm.prescriptions ; let $index=index">
                    <div class="c-content c-content--border-bottom u-no-ph@md-and-up"
                         *ngIf="(prescription.drugIngredient && prescription.drugIngredient.enabled) || vm.showRenewablePrescriptions">
                      <div class="o-grid o-grid--wrap@up-to-md u-ost-sm@md-and-up">
                        <div class="o-grid__cell o-grid__cell--w-fit o-grid__cell--w-100 o-grid__cell--w-15@md-and-up u-no-p">
                          <p class="o-grid c-text c-text--sm@up-to-sm">
                            <span class="u-hidden@md-and-up">{{ 'PreVisit.Prescription_List.Prescription_Number' | translate }}: </span>
                            <span class="o-grid__cell--right@up-to-md">{{ prescription.prescriptionNumber }}</span>
                          </p>
                        </div>
                        <div class="o-grid__cell o-grid__cell--w-fit o-grid__cell--w-100 o-grid__cell--w-10@md-and-up u-no-p">
                          <p class="o-grid c-text c-text--sm@up-to-sm">
                            <span class="u-hidden@md-and-up">{{ 'PreVisit.Prescription_List.Date_Issued' | translate }}: </span>
                            <span class="o-grid__cell--right@up-to-md">{{ prescription.issued | date: 'dd.MM.yyyy' }}</span>
                          </p>
                        </div>
                        <div class="o-grid__cell o-grid__cell--w-fit o-grid__cell--w-100 o-grid__cell--w-15@md-and-up u-no-p">
                          <p class="o-grid c-text c-text--sm@up-to-sm">
                            <span class="u-hidden@md-and-up">{{ 'PreVisit.Prescription_List.Status' | translate }}: </span>
                            <span class="o-grid__cell--right@up-to-md">{{ vm.prescriptionStatusByCode[prescription.statusCode] }}</span>
                          </p>
                        </div>
                        <div class="o-grid__cell o-grid__cell--w-fit o-grid__cell--w-100 o-grid__cell--w-20@md-and-up u-no-p">
                          <p class="o-grid c-text c-text--sm@up-to-sm">
                            <span class="u-hidden@md-and-up">{{ 'PreVisit.Prescription_List.Substance' | translate }}: </span>
                            <span class="o-grid__cell--right@up-to-md">
                              {{ prescription.atcName ? prescription.atcName : prescription.pharmaceuticalFormName | lowerCase }}
                            </span>
                            <item-info-popover 
                                *ngIf="!prescription.drugIngredient || !prescription.drugIngredient.enabled"
                                [text]="vm.getDisclaimerTextForDisabled(prescription)"
                                placement="left"
                                (click)="$event.preventDefault()"
                                [color]="'red'"
                                class="u-osl-xs o-grid--center-h u-hidden@md-and-up"
                                style="color: red">
                            </item-info-popover>
                          </p>
                        </div>
                        <div class="o-grid__cell o-grid__cell--w-fit o-grid__cell--w-100 o-grid__cell--w-15@md-and-up u-no-p">
                          <p class="o-grid c-text c-text--sm@up-to-sm" *ngIf="prescription.statusCode === vm.prescriptionCreatedStatusCode">
                            <span class="u-hidden@md-and-up">{{ 'PreVisit.Prescription_List.Valid_Until' | translate }}: </span>
                            <span class="o-grid__cell--right@up-to-md">{{ prescription.validUntil | date: 'dd.MM.yyyy'}}</span>
                          </p>
                        </div>
                        <div class="o-grid__cell o-grid__cell--w-fit o-grid__cell--w-100 o-grid__cell--w-15@md-and-up u-no-p">
                          <p class="o-grid c-text c-text--sm@up-to-sm" *ngIf="prescription.soldPreparationName">
                            <span class="u-hidden@md-and-up">{{ 'PreVisit.Prescription_List.Sold_Preparation_Name' | translate }}: </span>
                            <span class="o-grid__cell--right@up-to-md">{{ prescription.soldPreparationName }}</span>
                          </p>
                        </div>
                        <div class="o-grid__cell u-no-p">
                          <div class="o-grid" *ngIf="!vm.isPreVisit">
                            <div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up o-grid__cell--right u-no-p"
                                 *ngIf="prescription.drugIngredient && prescription.drugIngredient.enabled">
                              <a id="renewButton1" [routerLink]="['/booking/prescription']" [queryParams]="vm.generatePrescriptionExtendLink(prescription)" class="c-text c-text--uppercase u-hidden@up-to-md">
                                {{'PreVisit.Prescription_List.Renew' | translate}}
                              </a>
                              <a id="renewButton2" [routerLink]="['/booking/prescription']" [queryParams]="vm.generatePrescriptionExtendLink(prescription)"
                                 class="c-button c-button--s1 c-button--narrow c-button--fit u-hidden@md-and-up u-ost-md@up-to-md">
                                {{'PreVisit.Prescription_List.Renew' | translate}}
                              </a>
                            </div>
														
                            <div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed o-grid__cell--center u-no-p u-hidden@up-to-md"
                                 *ngIf="!prescription.drugIngredient || !prescription.drugIngredient.enabled">
                              <item-info-popover
                                  [text]="vm.getDisclaimerTextForDisabled(prescription)"
                                  placement="left"
                                  (click)="$event.preventDefault()"
                                  [color]="'red'"
                                  class="u-osl-xs o-grid--center-h"
                                  style="float: right;color: red"></item-info-popover>
                            </div>
                          </div>
                          <div class="o-grid" *ngIf="vm.isPreVisit">
                            <div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up o-grid__cell--right u-no-p">
                              <label class="c-checkbox" >
                                <input type="checkbox" name="prescription.prescriptionNumber" [(ngModel)]="vm.selectedPrescriptionIds[prescription.prescriptionNumber]">
                                <span id="selectPrescriptionLabel{{$index}}"> </span>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
                <div class="o-grid__cell o-grid__cell--w-100 c-text--right u-no-p" *ngIf="vm.isPreVisit && vm.prescriptions?.length">
                  <button id="continuePrescriptionRenewalButton" class="c-button c-button--s1 u-osb-sm u-ost-sm" (click)="vm.showFreeInputSection = true">
                    <span>{{'Common.Next' | translate}}</span>
                  </button>
                </div>
              </div>
              
              <div *ngIf="!vm.prescriptions?.length">
                <div class="o-grid o-grid--center-h" >
                  <div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--center-h u-no-p">
                    <img alt="No results" src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/bg-empty.svg" style="max-width:350px;margin-top:40px;">
                  </div>
                </div>
                <div class="o-grid o-grid--center-h">
                  <div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--center-h u-no-p">
                    <p class="c-text c-text--gray c-text--center c-text--lg u-ost-md">{{ 'Services.Title.NoContent' | translate }}</p>
                  </div>
                </div>
              </div>
              
            </div>
            <loader-overlay *ngIf="vm.loading"></loader-overlay>
          </div>
        </div>
      </div>
    </div>
</section>
</div>

<div class="u-wrapper" [ngStyle]="!vm.isInitialized && {'min-height': '200px'}" *ngIf="vm.showFreeInputSection">
	<div class="c-card u-osb-md">
		<div class="c-content c-content--lg">
			<div class="o-grid">
				<div class="o-grid__cell">
					<div>
						<label for="patientNoteForDoctor" class="c-form__label u-osb-xs" [innerHtml]="vm.otherDescriptionConfLabel"></label>
						<textarea id="patientNoteForDoctor" name="vm.patientNoteForDoctor" class="c-form__input"
									 [(ngModel)]="vm.patientNoteForDoctor" ></textarea>
					</div>
					<div class="o-grid__cell o-grid__cell--w-100 c-text--right u-no-p u-ost-md">
						<button id="backButton" class="c-button c-button--s6 u-ost-sm@md-and-up c-button--fit@up-to-sm u-osr-md@md-and-up" (click)="vm.showFreeInputSection = false">
							<span>{{'Common.Back' | translate}}</span>
						</button>
						<button id="submitPreVisitPrescriptionRenewalButton" class="c-button c-button--s1 u-ost-sm@md-and-up c-button--fit@up-to-sm u-ost-md" (click)="vm.submitPreVisitPrescriptionRenewal()">
							<span>{{'PreVisit.Prescription_List.Renew_Selected' | translate}}</span>
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<pre-visit-thank-you *ngIf="vm.showOnlyThankYouSection"
										 [isInitialized]="vm.isInitialized"
										 [isRecordTicketForPerson]="vm.isRecordTicketForPerson"
										 [informationSection]="vm.thankYouInformationSection"
										 [preVisitTicketId]="vm.preVisitTicketId">
</pre-visit-thank-you>
